import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { GlobalStyles } from './global-styles';

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAHZY5YicQgLY-d3T4EDy7iFJWGsF36aKo",
  authDomain: "react-portfolio-978e3.firebaseapp.com",
  projectId: "react-portfolio-978e3",
  storageBucket: "react-portfolio-978e3.appspot.com",
  messagingSenderId: "343865392803",
  appId: "1:343865392803:web:c44c7a14873595eea40916"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

ReactDOM.render(
  <>
    <GlobalStyles />
    <App />
  </>,
  document.getElementById('root')
);
